import React, { Component } from 'react'

class MaintenanceServiceOverview extends Component {
  render() {
    const { overviewTotals } = this.props
    return (
      <div className="row infoBoxRow">
        <div
          className="infoBox"
          onClick={() => this.props.navToSection('Job Site Material Requests')}
        >
          <div className="infoBoxNumber">
            {overviewTotals && overviewTotals.materialRequestTotals}
          </div>
          <div className="infoBoxText">Material Requests</div>
        </div>
        <div className="infoBox" onClick={() => this.props.navToSection('Job Site Repair Orders')}>
          <div className="infoBoxNumber">{overviewTotals && overviewTotals.repairOrderTotals}</div>
          <div className="infoBoxText">Repair Orders</div>
        </div>
        <div
          className="infoBox"
          onClick={() => this.props.navToSection('Job Site Driver Requests')}
        >
          <div className="infoBoxNumber">
            {overviewTotals && overviewTotals.driverRequestTotals}
          </div>
          <div className="infoBoxText">Driver Requests</div>
        </div>
        <div className="infoBox" onClick={() => this.props.navToSection('Job Site Service Orders')}>
          <div className="infoBoxNumber">{overviewTotals && overviewTotals.serviceOrderTotals}</div>
          <div className="infoBoxText">Service Orders</div>
        </div>
      </div>
    )
  }
}

export default MaintenanceServiceOverview



// WEBPACK FOOTER //
// ./src/components/jobs/overview/MaintenanceServiceOverview.js